export enum SiteHeaderTypes {
  BLUR = "blur",
  GREEN = "green",
  LIGHT_GREY = "light-grey",
  LIGHT = "light",
  NONE = "none"
}
